import React, { FC, useEffect, useState } from "react";
import { Combobox, ComboboxProps, Label, Tooltip, tokens, useId } from "@fluentui/react-components";
import { Info16Regular } from "@fluentui/react-icons";
import { useDebounce } from "use-debounce";
import "./LabeledCombobox.scss";

//pass the options as children to this element
interface ILabeledComboboxProps {
    label: string;
    onOptionSelect: ComboboxProps["onOptionSelect"];
    value: string;
    disabled?: boolean;
    onInput?: (val: string) => void;
    onInputDebounceTime?: number; // debounce time for the onInput prop in ms.
    tooltip?: string;
}

export const LabeledCombobox: FC<ILabeledComboboxProps> = (props) => {
    const [currentVal, setCurrentVal] = useState(props.value);
    const [tooltipVisible, setTooltipVisible] = useState(false);
    const [debouncedVal] = useDebounce(currentVal, props.onInputDebounceTime ? props.onInputDebounceTime : 0);
    const comboId = useId("combo-default");

    useEffect(() => {
        if(props.value != currentVal) {
            setCurrentVal(props.value);
        }
    }, [props.value]);

    useEffect(() => {
        if(props.onInput) {
            props.onInput(debouncedVal);
        }
    }, [debouncedVal]);

    const onInput = (ev: React.ChangeEvent<HTMLInputElement>) => {
        setCurrentVal(ev.target.value);
    }


    return (
        <>
            <Label className="c-field-label" id={comboId}>
                {props.label}
                {props.tooltip && (
                    <Tooltip
                        content={{
                            children: props.tooltip
                        }}
                        positioning="above-start"
                        withArrow
                        relationship="label"
                        onVisibleChange={(e, data) => setTooltipVisible(data.visible)}
                    >
                        <Info16Regular
                            tabIndex={0}
                            style={ tooltipVisible ? { color: tokens.colorNeutralForeground2BrandSelected } : {}}
                            className="c-tooltip-icon"
                        />
                  </Tooltip>
                )}
            </Label>
            <Combobox 
                onOptionSelect={props.onOptionSelect} 
                value={currentVal} 
                onInput={onInput}
                aria-labelledby={comboId} 
                disabled={props.disabled}
                >
                {props.children}
            </Combobox>
        </>
    )
}

